import { BackDropConstants } from '../types/BackDropConstants';

export function backdrop(state = {show : false}, action) {
  switch (action.type) {
    case BackDropConstants.START:
      return {
        show : true
      };
    case BackDropConstants.END:
      return {
        show : false
      };
    default:
      return state
  }
}